<template>
    <div class="directory-embedded-list">
            <div class="directory-list-toolbar">
                <div class="directory-search">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    <input type="text" :placeholder="$t('Search Region here...')" class="form-control" :value="regionSearch" @input="searchRegion($event.target.value)"/>
                </div>
                <div class="directory-pagination" v-if="regionList.totalDocs">
                <Pagination
                    :paginationDetails="{totalPages : regionList.totalPages, page : regionList.page}"
                    :changePage="ChangePage" 
                ></Pagination>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-striped directory-table">
                    <thead>
                        <tr>
                            <th>{{ $t('Name') }}</th>
                            <th>{{ $t('Created At') }}</th>
                            <th class="directory-status-col">{{ $t('Status') }}</th>
                            <th></th>
                        </tr>
                    </thead>  
                    <tbody class="text-capitalize">
                        <tr v-if="regionList.totalDocs==0">
                            <td class="text-center directory-empty-state" colspan="4">{{ $t('No Data Found') }}</td>
                        </tr>
                        <tr v-for="(item, index) in  regionList.docs" :key="item._id || index" :class="{ 'is-highlighted': item._id === highlightedRegionId }">
                            <td class="directory-user-name">{{item.regionName}}</td>
                            <td>{{formatDate(item.createdAt)}}</td>
                            <td class="directory-status-col">
                                <span class="badge bg-primary text-white" v-if="item.status">{{ $t('Active') }}</span>
                                <span class="badge bg-danger text-white" v-else>{{ $t('Inactive') }}</span>
                            </td>
                            <td class="directory-table__actions">
                                <button class="directory-icon-btn directory-icon-btn--edit" @click="SetRegionUpdate({_id : item._id, regionName : item.regionName})" :title="$t('Edit')" data-bs-toggle="modal" data-bs-target="#UpdateRegionModal"><i class="fa-solid fa-pen"></i></button>
                                <button class="directory-icon-btn directory-icon-btn--status" @click="ChangeStatus(item)" :title="item.status ? $t('Deactivate Region') : $t('Activate Region')"><i class="fa-solid fa-lock"></i></button>
                            </td>
                        </tr>
                    </tbody>
                    
                </table>
            </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Pagination from '@/components/layout/Pagination.vue'
import {ReformatDate} from '@/helpers/utilities.js'
import {confirmDirectoryStatusChange} from '@/helpers/directoryStatusConfirm.js'
export default {
    name : 'RegionList',
    components : {
        Pagination
    },
    data(){
        return {
            timer : null
        }
    },
    methods : {
        ...mapActions(['GetRegionList','UpdateRegionStatusRun','SetRegionUpdate','ClearRegionHighlight']),
        ChangePage (page){
            this.ClearRegionHighlight()
            this.GetRegionList({search : this.regionSearch, page : page}).catch()
        },
        timerSetter(typed, callback, seachEmpty = false){
            const self = this
            if(!seachEmpty){
                if(!typed){
                return
                }
            }
            
            if(self.timer){
                clearTimeout(self.timer)
                self.timer = null
            }

            self.timer = setTimeout(callback,700)
        },
        searchRegion(search){
            const self = this
            self.ClearRegionHighlight()
            self.timerSetter(search,function(){
                self.GetRegionList({search : search, page : 1}).catch()
            },true)
        },
        formatDate(value){
            return ReformatDate(value)
        },
        ChangeStatus(region){
            return confirmDirectoryStatusChange(this, {
                entityName: 'Region',
                itemName: region.regionName,
                isActive: Boolean(region.status),
                onConfirm: () => this.UpdateRegionStatusRun(region._id),
                successDescriptionBuilder: ({ completedAction, highlightedName, nextStatus }) => `${highlightedName} region has been ${completedAction.toLowerCase()} successfully. The region status is now ${nextStatus}.`,
                errorMessage: 'Unable to update region status.'
            })
        }
    },
    computed : mapGetters(['regionList','regionSearch','highlightedRegionId'])
    
}
</script>
